import { render, staticRenderFns } from "./CustomerCommon.vue?vue&type=template&id=8b057932"
import script from "./CustomerCommon.vue?vue&type=script&lang=ts"
export * from "./CustomerCommon.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCommon.vue?vue&type=style&index=0&id=8b057932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports